export const DIGEN_SITE = process.env.NEXT_PUBLIC_DIGEN_SITE || 'https://digen.ai'
export const BLOG_SITE = 'https://blog.digen.ai'
export const RESOURCES_SITE = 'https://resource.digen.ai'
